<template>
    <div class="fatturazione-dashboard">
        <div v-if="isLoading">Caricamento in corso...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else>
            <h1 class="dashboard-title">Fatture anomale</h1>

            <div class="cards-container">
                <div class="info-card" :class="{ 'solo-header': !visibileSezioni.dettagliFattura }">
                    <div class="info-card-header" @click="toggleSezione('dettagliFattura')"
                        :class="{ 'solo': !visibileSezioni.dettagliFattura }">
                        <div class="header-content">
                            <h3 class="section-title">Dettagli Fattura</h3>
                            <span class="toggle-icon">
                                {{ visibileSezioni.dettagliFattura ? '▲' : '▼' }}
                            </span>
                        </div>
                    </div>
                    <div class="info-card-content" v-if="visibileSezioni.dettagliFattura">
                        <div class="info-row" v-for="(label, key) in intestazioniFattura" :key="key" :class="{
                            'important': ['preview_totale_qta', 'auto_potenza_impegnata'].includes(key),
                            'consumo-anomalo': key === 'preview_totale_qta' && isConsumoAnomalo(),
                            'potenza-anomala': key === 'auto_potenza_impegnata' && isPotenzaAnomala(),
                            'imponibile-anomalo': key === 'imponibile' && isImponibileAnomalo()
                        }">
                            <span class="info-label">{{ label }}</span>
                            <span class="info-value" :class="{
                                'consumo-fatturato-rosso': key === 'preview_totale_qta' && isConsumoAnomalo(),
                                'potenza-fatturata-rosso': key === 'auto_potenza_impegnata' && isPotenzaAnomala(),
                                'imponibile-fattura-rosso': key === 'imponibile' && isImponibileAnomalo()
                            }">
                                <span v-if="key === 'numero'" class="numero-fattura-container">
                                    <span class="numero-fattura">{{ dettagliFattura[key] || '-' }}</span>
                                    <div class="fattura-actions">
                                        <button @click="downloadPDF()" class="action-btn download-btn"
                                            title="Scarica PDF">
                                            ⬇
                                        </button>
                                        <button @click="viewPDF()" class="action-btn view-btn"
                                            title="Visualizza Dettaglio">
                                            👁
                                        </button>
                                    </div>
                                </span>
                                <span v-else>
                                    {{ key === 'preview_totale_qta' ? dettagliFattura[key] + ' kWh' :
                                        key.includes('imponibile') || key.includes('totale') ?
                                            formatCurrency(dettagliFattura[key]) :
                                            key === 'creation_time' ? formatDate(dettagliFattura[key]) :
                                                key === 'auto_potenza_impegnata' ? dettagliFattura[key] + ' kW' :
                                                    dettagliFattura[key] || '-' }}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="info-card" :class="{ 'solo-header': !visibileSezioni.dettagliCliente }">
                    <div class="info-card-header" @click="toggleSezione('dettagliCliente')"
                        :class="{ 'solo': !visibileSezioni.dettagliCliente }">
                        <div class="header-content">
                            <h3 class="section-title">Dettagli Cliente</h3>
                            <span class="toggle-icon">
                                {{ visibileSezioni.dettagliCliente ? '▲' : '▼' }}
                            </span>
                        </div>
                    </div>
                    <div class="info-card-content" v-if="visibileSezioni.dettagliCliente">
                        <div class="info-row">
                            <span class="info-label">Cliente:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);"
                                    @click="navigateToClienteDetail(dettagliFattura.cliente_id)" class="link-pod">
                                    {{ formatNomeCliente(dettagliFattura.ragsoc, dettagliFattura.nome,
                                        dettagliFattura.cognome) }}
                                </a>
                            </span>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Codice POD:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);" @click="navigateToPodDetail(dettagliFattura.pod_id)"
                                    class="link-pod">
                                    {{ dettagliFattura.code }}
                                </a>
                            </span>
                        </div>

                        <div class="info-row important">
                            <span class="info-label">Potenza Disponibile:</span>
                            <span class="info-value">{{ dettagliFattura.potenza_disponibile }} kW</span>
                        </div>

                        <div class="info-row important">
                            <span class="info-label">Consumo:</span>
                            <div class="info-value consumo-values">
                                <div class="consumo-item">
                                    <span class="consumo-label">Totale</span>
                                    <span class="consumo-value">{{ dettagliFattura.consumo_annuo }} kWh</span>
                                </div>
                                <div class="consumo-item">
                                    <span class="consumo-label">Totale/12</span>
                                    <span class="consumo-value">{{ Math.round(dettagliFattura.consumo_annuo / 12) }}
                                        kWh</span>
                                </div>
                            </div>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Tipo Consumo:</span>
                            <span class="info-value">{{ dettagliFattura.consumo }}</span>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Rappresentante:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);"
                                    @click="navigateToRappresentanteDetail(dettagliFattura.rappresentante_id)"
                                    class="link-pod" v-if="dettagliFattura.rappresentante">
                                    {{ dettagliFattura.rappresentante }}
                                </a>
                                <span v-else>Non assegnato</span>
                            </span>
                        </div>

                        <div class="info-row">
                            <span class="info-label">Agente:</span>
                            <span class="info-value">
                                <a href="javascript:void(0);" @click="navigateToAgenteDetail(dettagliFattura.agente_id)"
                                    class="link-pod" v-if="dettagliFattura.agente">
                                    {{ dettagliFattura.agente }}
                                </a>
                                <span v-else>Non assegnato</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Blocco Letture</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoLetture')">
                        {{ visibileSezioni.bloccoLetture ? '▲' : '▼' }}
                    </span>
                </div>
                <div v-if="visibileSezioni.bloccoLetture">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>Data Comunicazione</th>
                                    <th>Periodo</th>
                                    <th>F1</th>
                                    <th>F2</th>
                                    <th>F3</th>
                                    <th>Energia</th>
                                    <th>F1 R</th>
                                    <th>F2 R</th>
                                    <th>F3 R</th>
                                    <th>Energia R</th>
                                    <th>Pot F1</th>
                                    <th>Pot F2</th>
                                    <th>Pot F3</th>
                                    <th>Usato</th>
                                    <th>Autolettura</th>
                                    <th>Tipo</th>
                                    <th>Validato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!dettagliFattura.letture || dettagliFattura.letture.length === 0">
                                    <td colspan="17" class="no-data-message">Nessuna lettura disponibile</td>
                                </tr>
                                <tr v-else v-for="(lettura, index) in paginatedLetture" :key="index">
                                    <td>{{ formatDate(lettura.data_comunicazione) }}</td>
                                    <td>{{ formatPeriodo(lettura.data_lettura) }}</td>
                                    <td>{{ lettura.f1 || 0 }}</td>
                                    <td>{{ lettura.f2 || 0 }}</td>
                                    <td>{{ lettura.f3 || 0 }}</td>
                                    <td>{{ ((lettura.f1 || 0) + (lettura.f2 || 0) + (lettura.f3 || 0)).toFixed(2) }}
                                    </td>
                                    <td>{{ lettura.erf1 || 0 }}</td>
                                    <td>{{ lettura.erf2 || 0 }}</td>
                                    <td>{{ lettura.erf3 || 0 }}</td>
                                    <td>{{ ((lettura.erf1 || 0) + (lettura.erf2 || 0) + (lettura.erf3 || 0)).toFixed(2)
                                    }}</td>
                                    <td>{{ lettura.pf1 || 0 }}</td>
                                    <td>{{ lettura.pf2 || 0 }}</td>
                                    <td>{{ lettura.pf3 || 0 }}</td>
                                    <td class="text-center">
                                        <span v-if="lettura.used" class="status-icon success">✓</span>
                                        <span v-else class="status-icon error">✗</span>
                                    </td>
                                    <td>{{ lettura.autolettura ? "SI" : "NO" }}</td>
                                    <td>{{ lettura.tipo || '-' }}</td>
                                    <td>{{ lettura.validato || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pagination-container"
                        v-if="dettagliFattura.letture && dettagliFattura.letture.length > itemsPerPage">
                        <div class="pagination-info">
                            {{ (currentPageLetture - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageLetture * itemsPerPage, dettagliFattura.letture.length) }}
                            di {{ dettagliFattura.letture.length }} elementi
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageLetture = 1"
                                :disabled="currentPageLetture === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageLetture--"
                                :disabled="currentPageLetture === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageLetture }} / {{ totalPagesLetture }}</span>
                            <button class="pagination-btn" @click="currentPageLetture++"
                                :disabled="currentPageLetture === totalPagesLetture">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageLetture = totalPagesLetture"
                                :disabled="currentPageLetture === totalPagesLetture">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Mensilità Reali</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoMensilita')">
                        {{ visibileSezioni.bloccoMensilita ? '▲' : '▼' }}
                    </span>
                </div>
                <div v-if="visibileSezioni.bloccoMensilita">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>Data Comunicazione</th>
                                    <th>F1</th>
                                    <th>F2</th>
                                    <th>F3</th>
                                    <th>Energia</th>
                                    <th>F1 R</th>
                                    <th>F2 R</th>
                                    <th>F3 R</th>
                                    <th>Energia R</th>
                                    <th>Pot F1</th>
                                    <th>Pot F2</th>
                                    <th>Pot F3</th>
                                    <th>Usato</th>
                                    <th>Fattura</th>
                                    <th>Palleggia</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="!dettagliFattura.mensilita_reali || dettagliFattura.mensilita_reali.length === 0">
                                    <td colspan="15" class="no-data-message">Nessuna mensilità disponibile</td>
                                </tr>
                                <tr v-else v-for="(mensile, index) in paginatedMensilita" :key="index">
                                    <td>{{ formatDate(mensile.data) || formatDate(mensile.data) }}</td>
                                    <td>{{ mensile.f1 || 0 }}</td>
                                    <td>{{ mensile.f2 || 0 }}</td>
                                    <td>{{ mensile.f3 || 0 }}</td>
                                    <td>{{ ((mensile.f1 || 0) + (mensile.f2 || 0) + (mensile.f3 || 0)).toFixed(2) }}
                                    </td>
                                    <td>{{ mensile.f1_r || 0 }}</td>
                                    <td>{{ mensile.f2_r || 0 }}</td>
                                    <td>{{ mensile.f3_r || 0 }}</td>
                                    <td>{{ ((mensile.f1_r || 0) + (mensile.f2_r || 0) + (mensile.f3_r || 0)).toFixed(2)
                                    }}</td>
                                    <td>{{ mensile.pf1 || 0 }}</td>
                                    <td>{{ mensile.pf2 || 0 }}</td>
                                    <td>{{ mensile.pf3 || 0 }}</td>
                                    <td class="text-center">
                                        <span v-if="mensile.used" class="status-icon success">✓</span>
                                        <span v-else class="status-icon error">✗</span>
                                    </td>
                                    <td>{{ mensile.used_ft || '-' }}</td>
                                    <td class="text-center">
                                        <button 
                                            v-if="!mensile.used"
                                            @click="onMensilitaRealeUsed2(dettagliFattura.pod_id, mensile.id_mensilita)"
                                            class="action-btn used2-btn"
                                            title="Palleggia">
                                            ⚠
                                        </button>
                                        <span v-else class="status-icon success">✓</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Paginatore per Mensilità -->
                    <div class="pagination-container"
                        v-if="dettagliFattura.mensilita_reali && dettagliFattura.mensilita_reali.length > itemsPerPage">
                        <div class="pagination-info">
                            {{ (currentPageMensilita - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageMensilita * itemsPerPage, dettagliFattura.mensilita_reali.length) }}
                            di {{ dettagliFattura.mensilita_reali.length }} elementi
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageMensilita = 1"
                                :disabled="currentPageMensilita === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageMensilita--"
                                :disabled="currentPageMensilita === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageMensilita }} / {{ totalPagesMensilita }}</span>
                            <button class="pagination-btn" @click="currentPageMensilita++"
                                :disabled="currentPageMensilita === totalPagesMensilita">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageMensilita = totalPagesMensilita"
                                :disabled="currentPageMensilita === totalPagesMensilita">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Dettagli di questa fattura</h3>
                    <span class="toggle-icon" @click="toggleSezione('bloccoDettagli')">
                        {{ visibileSezioni.bloccoDettagli ? '▲' : '▼' }}
                    </span>
                </div>
                <div v-if="visibileSezioni.bloccoDettagli">
                    <div class="fatture-table-wrapper">
                        <table class="fatture-table">
                            <thead>
                                <tr>
                                    <th>Voce</th>
                                    <th>Quantità</th>
                                    <th>Prezzo Unitario €</th>
                                    <th>Aliquota IVA %</th>
                                    <th>Imponibile</th>
                                    <th>Importo IVA</th>
                                    <th>Totale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="!dettagliFattura.dettagli_fattura || dettagliFattura.dettagli_fattura.length === 0">
                                    <td colspan="7" class="no-data-message">Nessun dettaglio disponibile</td>
                                </tr>
                                <tr v-else v-for="(dettaglio, index) in paginatedDettagli" :key="index">
                                    <td class="voce-nome">
                                        <div class="voce-info">
                                            <strong>{{ dettaglio.cod_voce || '-' }}</strong>
                                            <div v-if="dettaglio.descrizione" class="voce-descrizione">
                                                {{ dettaglio.descrizione }}
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{ formatNumber(dettaglio.qta) }}</td>
                                    <td>{{ formatCurrency(dettaglio.unitario) }}</td>
                                    <td>{{ formatPercentage(dettaglio.iva) }}</td>
                                    <td>{{ formatCurrency(dettaglio.totale) }}</td>
                                    <td>{{ formatCurrency(dettaglio.importo_iva) }}</td>
                                    <td class="font-bold">{{ formatCurrency(dettaglio.totale_ivato) }}</td>
                                </tr>
                            </tbody>
                            <tfoot
                                v-if="dettagliFattura.dettagli_fattura && dettagliFattura.dettagli_fattura.length > 0">
                                <tr class="totali-row">
                                    <td colspan="4">TOTALI:</td>
                                    <td>{{ formatCurrency(totaleImponibile) }}</td>
                                    <td>{{ formatCurrency(totaleIva) }}</td>
                                    <td>{{ formatCurrency(totaleGenerale) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <!-- Paginatore per Dettagli -->
                    <div class="pagination-container"
                        v-if="dettagliFattura.dettagli_fattura && dettagliFattura.dettagli_fattura.length > itemsPerPage">
                        <div class="pagination-info">
                            {{ (currentPageDettagli - 1) * itemsPerPage + 1 }} -
                            {{ Math.min(currentPageDettagli * itemsPerPage, dettagliFattura.dettagli_fattura.length) }}
                            di {{ dettagliFattura.dettagli_fattura.length }} elementi
                        </div>
                        <div class="pagination-controls">
                            <button class="pagination-btn" @click="currentPageDettagli = 1"
                                :disabled="currentPageDettagli === 1">
                                ««
                            </button>
                            <button class="pagination-btn" @click="currentPageDettagli--"
                                :disabled="currentPageDettagli === 1">
                                ‹
                            </button>
                            <span class="page-indicator">{{ currentPageDettagli }} / {{ totalPagesDettagli }}</span>
                            <button class="pagination-btn" @click="currentPageDettagli++"
                                :disabled="currentPageDettagli === totalPagesDettagli">
                                ›
                            </button>
                            <button class="pagination-btn" @click="currentPageDettagli = totalPagesDettagli"
                                :disabled="currentPageDettagli === totalPagesDettagli">
                                »»
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="fatture-table-container">
                <div class="fatture-table-header">
                    <h3 class="section-title">Dettaglio Fatturazione</h3>
                </div>

                <div class="fatture-summary">
                    <div class="summary-item">
                        <span class="summary-label">Media Fatture</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.media) }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">Ultima Fattura</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.lastfatt) }}</span>
                    </div>
                    <div class="summary-item">
                        <span class="summary-label">Imponibile Massimo</span>
                        <span class="summary-value">{{ formatCurrency(dettagliFattura.maxfatt) }}</span>
                    </div>
                </div>

                <div class="fatture-table-wrapper">
                    <table class="fatture-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Numero</th>
                                <th>Data</th>
                                <th>Mese Fatturazione</th>
                                <th>Cliente</th>
                                <th>POD</th>
                                <th>Imponibile</th>
                                <th>Totale</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="!dettagliFattura.fatture_tabella || dettagliFattura.fatture_tabella.length === 0">
                                <td colspan="7" class="no-data-message">Nessuna fattura disponibile</td>
                            </tr>
                            <tr v-else v-for="fattura in dettagliFattura.fatture_tabella" :key="fattura.id">
                                <td>{{ fattura.id }}</td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToFatturaDetail(fattura.numero)"
                                        class="link-pod">
                                        {{ fattura.numero }}
                                    </a>
                                </td>
                                <td>{{ formatDate(fattura.data) }}</td>
                                <td>{{ formatDate(fattura.mese_fatturazione) }}</td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToClienteDetail(fattura.cliente_id)"
                                        class="link-pod">
                                        {{ fattura.cliente_nome }}
                                    </a>
                                </td>
                                <td>
                                    <a href="javascript:void(0);" @click="navigateToPodDetail(fattura.pod_id)"
                                        class="link-pod">
                                        {{ fattura.pod_code }}
                                    </a>
                                </td>
                                <td>{{ formatCurrency(fattura.imponibile) }}</td>
                                <td>{{ formatCurrency(fattura.totale) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="fattura-controls-container">
                <div class="approval-actions">
                    <button class="approval-button approve-button" @click="updateStatoFattura('approva')">
                        Approva Fattura
                    </button>
                    <button class="approval-button reject-button" @click="updateStatoFattura('scarta')">
                        Scarta Fattura
                    </button>
                </div>
            </div>

            <div class="modal-overlay" v-if="showValidazioneModal" @click.self="showValidazioneModal = false">
                <div class="modal-content modal-smaller">
                    <div class="modal-header"
                        :class="azioneValidazione === 'approva' ? 'modal-header-approve' : 'modal-header-reject'">
                        <h3>{{ azioneValidazione === 'approva' ? 'Approva' : 'Scarta' }} Fattura</h3>
                        <button class="close-button" @click="showValidazioneModal = false">&times;</button>
                    </div>
                    <div class="modal-body compact-body">
                        <p class="modal-message">
                            Stai per {{ azioneValidazione === 'approva' ? 'approvare' : 'scartare' }}
                            la fattura n. <strong>{{ dettagliFattura?.numero }}</strong>.
                        </p>

                        <div class="form-group">
                            <label for="note-validazione">Note <span class="required-asterisk">*</span></label>
                            <textarea id="note-validazione" v-model="noteValidazione" rows="2" :class="{
                                'textarea-approve': azioneValidazione === 'approva',
                                'textarea-reject': azioneValidazione === 'scarta',
                                'error-border': noteValidazioneError
                            }" placeholder="Inserisci le note sulla validazione (obbligatorio)..." required>
                            </textarea>
                            <div v-if="noteValidazioneError" class="field-error">
                                {{ noteValidazioneError }}
                            </div>
                        </div>


                        <div v-if="validazioneError" class="error-message">
                            {{ validazioneError }}
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-cancel" @click="showValidazioneModal = false">Annulla</button>
                        <button :class="['btn-submit', azioneValidazione === 'approva' ? 'btn-approve' : 'btn-reject']" @click="validaFattura()" :disabled="validazioneInProgress">
                            {{ validazioneInProgress ? 'Elaborazione...' : 'Conferma' }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="modal-overlay" v-if="showSuccessModal">
                <div class="modal-content modal-smaller modal-success">
                    <div class="modal-header"
                        :class="successAction === 'approva' ? 'modal-header-approve' : 'modal-header-reject'">
                        <h3>Operazione Completata</h3>
                        <button class="close-button" @click="closeSuccessModal">&times;</button>
                    </div>
                    <div class="modal-body compact-body">
                        <p class="success-message">
                            {{ successAction === 'approva' ?
                                'Fattura approvata con successo!' :
                                'Fattura scartata con successo!' }}
                        </p>
                        <p class="success-details">
                            Numero Fattura: <strong>{{ successFatturaNumero }}</strong><br>
                            Cliente: <strong>{{ successFatturaCliente }}</strong>
                        </p>
                    </div>
                    <div class="modal-footer">
                        <!-- <button class="btn-secondary" @click="closeSuccessModal">
                            Continua con questa fattura
                        </button> -->
                        <button class="btn-success"
                            :class="successAction === 'approva' ? 'btn-success-approve' : 'btn-success-reject'"
                            @click="loadNextInvoice">
                            Carica Prossima Fattura
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PreviewFatture',
    data() {
        return {
            previewFattureService: null,
            dettagliFattura: {
                letture: [],
                mensilita_reali: [],
                dettagli_fattura: [],
                fatture_tabella: []
            },
            isLoading: true,
            error: null,
            itemsPerPage: 10,
            currentPageLetture: 1,
            currentPageMensilita: 1,
            currentPageDettagli: 1,
            noteValidazioneError: null,
            visibileSezioni: {
                dettagliFattura: true,
                dettagliCliente: true,
                bloccoLetture: true,
                bloccoMensilita: true,
                bloccoDettagli: true
            },
            intestazioniFattura: {
                numero: 'Numero Fattura',
                creation_time: 'Data',
                auto_potenza_impegnata: 'Potenza Fatturata',
                preview_totale_qta: 'Consumo Fatturato',
                mese_fatturazione: 'Mese Fatturazione',
                imponibile: 'Imponibile',
                totale: 'Totale',
                pay: 'Metodo Pagamento',
                scadenza: 'Scadenza'
            },
            showValidazioneModal: false,
            azioneValidazione: 'approva',
            noteValidazione: '',
            validazioneInProgress: false,
            validazioneError: null,
            showSuccessModal: false,
            successAction: 'approva',
            successFatturaNumero: '',
            successFatturaCliente: '',
            showStoriaValidazioniModal: false,
            storiaValidazioni: [],
            caricamentoStoriaValidazioni: false
        };
    },
    computed: {
        totalPagesLetture() {
            const letture = this.dettagliFattura?.letture;
            if (!letture || !Array.isArray(letture) || letture.length === 0) return 1;
            return Math.ceil(letture.length / this.itemsPerPage);
        },
        paginatedLetture() {
            const letture = this.dettagliFattura?.letture;
            if (!letture || !Array.isArray(letture)) return [];
            const start = (this.currentPageLetture - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return letture.slice(start, end);
        },
        totalPagesMensilita() {
            const mensilita = this.dettagliFattura?.mensilita_reali;
            if (!mensilita || !Array.isArray(mensilita) || mensilita.length === 0) return 1;
            return Math.ceil(mensilita.length / this.itemsPerPage);
        },
        paginatedMensilita() {
            const mensilita = this.dettagliFattura?.mensilita_reali;
            if (!mensilita || !Array.isArray(mensilita)) return [];
            const start = (this.currentPageMensilita - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return mensilita.slice(start, end);
        },
        totalPagesDettagli() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli) || dettagli.length === 0) return 1;
            return Math.ceil(dettagli.length / this.itemsPerPage);
        },
        paginatedDettagli() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return [];
            const start = (this.currentPageDettagli - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return dettagli.slice(start, end);
        },
        totaleImponibile() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.totale) || 0), 0);
        },
        totaleIva() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.importo_iva) || 0), 0);
        },
        totaleGenerale() {
            const dettagli = this.dettagliFattura?.dettagli_fattura;
            if (!dettagli || !Array.isArray(dettagli)) return 0;
            return dettagli.reduce((sum, item) => sum + (parseFloat(item.totale_ivato) || 0), 0);
        }
    },
    methods: {
        toggleSezione(sezione) {
            this.visibileSezioni[sezione] = !this.visibileSezioni[sezione];
        },
        async caricaFattura() {
            console.log('=== INIZIO caricaFattura ===');
            this.isLoading = true;
            this.error = null;

            try {
                const id = this.$route.params.id || this.$route.query.id || null;
                console.log('ID estratto:', id);

                if (!this.previewFattureService) {
                    throw new Error('Service non inizializzato');
                }

                console.log('Chiamata API in corso...');

                let response;
                try {
                    response = await this.previewFattureService.getDettaglioFattura(id, 3, 0);
                    console.log('Risposta ricevuta:', response);
                } catch (apiError) {
                    console.error('Errore specifico API:', apiError);
                    throw apiError; // Rilancia l'errore per gestirlo nel catch esterno
                }

                // Controlli sulla risposta
                if (!response) {
                    throw new Error('Nessuna risposta dal server');
                }

                console.log('Response status:', response.status);
                console.log('Response data exists:', !!response.data);

                if (!response.data) {
                    throw new Error('Risposta dal server senza dati');
                }

                console.log('Response data:', response.data);

                if (response.data.success === false) {
                    const errorMsg = response.data.message || 'Operazione fallita';
                    console.error('API ha restituito success: false -', errorMsg);
                    this.error = errorMsg;
                    return;
                }

                if (!response.data.success) {
                    console.warn('Success field non definito, controllo presenza dati...');
                }

                const data = response.data.data || response.data;
                console.log('Dati fattura estratti:', data);

                if (!data) {
                    throw new Error('Nessun dato fattura ricevuto');
                }

                if (!data.autofattura_id && !data.id && !data.numero) {
                    throw new Error('Dati fattura incompleti o non validi');
                }

                this.dettagliFattura = {
                    ...data,
                    letture: Array.isArray(data.letture) ? data.letture : [],
                    mensilita_reali: Array.isArray(data.mensilita_reali) ? data.mensilita_reali : [],
                    dettagli_fattura: Array.isArray(data.dettagli_fattura) ? data.dettagli_fattura : [],
                    fatture_tabella: Array.isArray(data.fatture_tabella) ? data.fatture_tabella : []

                };

                console.log('dettagliFattura finale:', this.dettagliFattura);
                this.resetPagination();
                console.log('=== FINE caricaFattura - SUCCESSO ===');

            } catch (error) {
                console.error('=== ERRORE in caricaFattura ===');
                console.error('Tipo errore:', error.constructor.name);
                console.error('Messaggio completo:', error.message);
                console.error('Stack:', error.stack);


                if (error.message.includes('Server non raggiungibile') ||
                    error.message.includes('ECONNREFUSED')) {
                    this.error = `🔌 ${error.message}\n\n💡 Soluzioni:\n• Avvia il server Laravel: php artisan serve --port=8001\n• Verifica che sia raggiungibile su http://localhost:8001\n• Controlla che non ci siano firewall che bloccano la porta 8001`;
                } else if (error.message.includes('Timeout') || error.message.includes('timeout')) {
                    this.error = `⏱️ ${error.message}\n\n💡 Il server impiega troppo tempo a rispondere.\nVerifica le performance del database.`;
                } else if (error.message.includes('Network Error')) {
                    this.error = `🌐 ${error.message}\n\n💡 Problema di rete.\nVerifica la connessione internet.`;
                } else if (error.message.includes('401')) {
                    this.error = '🔐 Sessione scaduta. Effettua nuovamente il login.';
                } else if (error.message.includes('404')) {
                    this.error = '📄 Endpoint non trovato. Verifica le route del backend.';
                } else if (error.message.includes('500')) {
                    this.error = '⚠️ Errore interno del server. Controlla i log di Laravel.';
                } else {
                    this.error = `❌ ${error.message}\n\nControlla la console per maggiori dettagli.`;
                }

            } finally {
                this.isLoading = false;
                console.log('Loading terminato, isLoading:', this.isLoading);
                console.log('Errore finale:', this.error);
            }
        },
        resetPagination() {
            this.currentPageLetture = 1;
            this.currentPageMensilita = 1;
            this.currentPageDettagli = 1;
        },

        updateStatoFattura(action) {
            if (!this.dettagliFattura) return;
            this.azioneValidazione = action;
            this.noteValidazione = '';
            this.validazioneError = null;
            this.noteValidazioneError = null;
            this.showValidazioneModal = true;
        },

        async validaFattura() {
            if (!this.dettagliFattura || this.validazioneInProgress) return;

            this.validazioneInProgress = true;
            this.validazioneError = null;
            this.noteValidazioneError = null;

            if (this.azioneValidazione == 'scarta' && (!this.noteValidazione || this.noteValidazione.trim() === '')) {
                this.noteValidazioneError = 'Le note sono obbligatorie';
                this.validazioneInProgress = false;
                return;
            }

            try {
                const response = await this.previewFattureService.updateStatoFattura(
                    this.dettagliFattura.autofattura_id,
                    this.azioneValidazione,
                    false,
                    this.noteValidazione.trim()
                );

                if (response.data.success) {
                    this.successAction = this.azioneValidazione;
                    this.successFatturaNumero = this.dettagliFattura.numero;
                    this.successFatturaCliente = this.formatNomeCliente(
                        this.dettagliFattura.ragsoc,
                        this.dettagliFattura.nome,
                        this.dettagliFattura.cognome
                    );

                    this.showSuccessModal = true;
                    this.showValidazioneModal = false;
                } else {
                    this.validazioneError = response.data.message || 'Errore nell\'elaborazione della richiesta';
                }
            } catch (error) {
                this.validazioneError = error.message || 'Errore nella comunicazione con il server';
            } finally {
                this.validazioneInProgress = false;
            }
        },

        async continuaConQuestaFattura() {
            if (!this.dettagliFattura || this.validazioneInProgress) return;

            this.validazioneInProgress = true;
            this.validazioneError = null;

            try {
                const response = await this.previewFattureService.updateStatoFattura(
                    this.dettagliFattura.autofattura_id,
                    this.azioneValidazione,
                    true
                );

                if (response.data.success) {
                    this.showValidazioneModal = false;
                    this.caricaFattura();
                } else {
                    this.validazioneError = response.data.message || 'Errore nell\'elaborazione della richiesta';
                }
            } catch (error) {
                this.validazioneError = error.message || 'Errore nella comunicazione con il server';
            } finally {
                this.validazioneInProgress = false;
            }
        },

        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleDateString('it-IT');
        },

        formatCurrency(value) {
            if (!value && value !== 0) return '-';
            return new Intl.NumberFormat('it-IT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },

        formatNumber(value) {
            if (!value && value !== 0) return '-';
            return new Intl.NumberFormat('it-IT', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },

        formatPercentage(value) {
            if (!value && value !== 0) return '-';
            return `${parseFloat(value).toFixed(0)}%`;
        },

        formatPeriodo(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleDateString('it-IT', {
                month: 'long',
                year: 'numeric'
            }).toUpperCase();
        },

        formatNomeCliente(ragsoc, nome, cognome) {
            return ragsoc || `${nome || ''} ${cognome || ''}`.trim() || 'Cliente senza nome';
        },

        navigateToClienteDetail(id) {
            if (!id) return;
            window.open(`/ask/clienti/${id}/dettagli`, '_blank');
        },

        navigateToFatturaDetail(numero) {
            if (!numero) return;
            window.open(`/ask/clienti/fatture/${numero}/dettagli`, '_blank');
        },
        navigateToPodDetail(id) {
            if (!id) return;
            window.open(`/ask/pods/${id}/dettagli`, '_blank');
        },

        navigateToRappresentanteDetail(id) {
            if (!id) return;
            window.open(`/ask/rappresentanti/${id}/dettagli`, '_blank');
        },

        navigateToAgenteDetail(id) {
            if (!id) return;
            window.open(`/ask/agenti/${id}/dettagli`, '_blank');
        },

        isConsumoAnomalo() {
            if (!this.dettagliFattura) return false;
            const qta = parseFloat(this.dettagliFattura.preview_totale_qta) || 0;
            const annuo = parseFloat(this.dettagliFattura.consumo_annuo) || 0;
            return qta > (annuo / 12);
        },

        isPotenzaAnomala() {
            if (!this.dettagliFattura) return false;
            return (
                (parseFloat(this.dettagliFattura.auto_potenza_impegnata) || 0) >
                (parseFloat(this.dettagliFattura.potenza_disponibile) || 0)
            );
        },

        isImponibileAnomalo() {
            if (!this.dettagliFattura) return false;
            return (
                (parseFloat(this.dettagliFattura.imponibile) || 0) >
                (parseFloat(this.dettagliFattura.maxfatt) || 0)
            );
        },

        async mostraStoriaValidazioni() {
            if (!this.dettagliFattura) return;
            this.showStoriaValidazioniModal = true;
            this.caricamentoStoriaValidazioni = true;

            try {
                const response = await this.previewFattureService.getValidazioni(this.dettagliFattura.autofattura_id);
                if (response.data.success) {
                    this.storiaValidazioni = response.data.data || [];
                }
            } catch (error) {
                console.error('Errore richiesta validazioni:', error);
            } finally {
                this.caricamentoStoriaValidazioni = false;
            }
        },

        downloadPDF() {
            console.log('Download PDF per fattura:', this.dettagliFattura.numero);
        },

        viewPDF() {
            console.log('Visualizza PDF per fattura:', this.dettagliFattura.numero);
        },

        closeSuccessModal() {
            this.showSuccessModal = false;
        },

        loadNextInvoice() {
            this.showSuccessModal = false;
            this.showValidazioneModal = false;
            this.caricaFattura();
        },

        async onMensilitaRealeUsed2(podId, mensilitaId) {
            try {
                const response = await this.previewFattureService.mensilitaRealeUsed2(podId, mensilitaId);
                if (response.success) {
                    // Ricarica i dati della fattura per aggiornare la tabella
                    await this.caricaFattura();
                }
            } catch (error) {
                console.error('Errore nel marcare mensilità come Used 2:', error);
            }
        }
    },

    watch: {
        'dettagliFattura.dettagli_fattura'() {
            this.currentPageDettagli = 1;
        }
    },
    created() {
        console.log('=== CREATED HOOK ===');

        try {
            const tipoValidazione = this.$route.query.tipo || 'luce';

            if (!this.$http) {
                console.error('$http non disponibile!');
                this.error = 'Servizio HTTP non disponibile';
                this.isLoading = false;
                return;
            }

            if (tipoValidazione === 'gas') {
                const PreviewFattureGasService = require('@/services/ask-fatturazione/previewfatturegas-service').default;
                this.previewFattureService = new PreviewFattureGasService(this.$http, this.$eventBus);
                console.log('Inizializzato PreviewFattureGasService');
            } else {
                const PreviewFattureService = require('@/services/ask-fatturazione/previewfatture-service').default;
                this.previewFattureService = new PreviewFattureService(this.$http, this.$eventBus);
                console.log('Inizializzato PreviewFattureService');
            }

            console.log('Avvio caricaFattura...');
            this.caricaFattura();

        } catch (error) {
            console.error('Errore in created():', error);
            this.error = 'Errore durante l\'inizializzazione: ' + error.message;
            this.isLoading = false;
        }
    }

};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');

* {
    font-family: 'Montserrat', sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

.fatturazione-dashboard {
    max-width: 1800px;
    margin: 0 auto;
    padding: 1.5rem;
    background-color: #eef2f7;
    min-height: 100vh;
}

.dashboard-title {
    font-size: 2.8rem !important;
    font-weight: 700 !important;
    color: #0d3c61 !important;
    margin: 0 0 1.5rem 0 !important;
    font-family: 'Montserrat', sans-serif !important;
    letter-spacing: -0.02em !important;
    position: relative !important;
    text-align: center !important;
    padding-bottom: 1rem !important;
}

.dashboard-title::after {
    content: '' !important;
    position: absolute !important;
    bottom: 0 !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    width: 100px !important;
    height: 4px !important;
    background: linear-gradient(90deg, #3288b3, #215159, #0d3c61) !important;
    border-radius: 2px !important;
}

.cards-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.info-card {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.info-card:hover {
    box-shadow: 0 8px 30px rgba(13, 60, 97, 0.15);
    transform: translateY(-2px);
}

.solo-header {
    background-color: transparent !important;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1) !important;
}

.info-card-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s ease;
}

.info-card-header:hover {
    background: linear-gradient(135deg, #1a5490, #0d3c61);
}

.info-card-header.solo {
    border-radius: 12px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section-title {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
}

.toggle-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 0.9rem;
    color: white;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.toggle-icon:hover {
    background-color: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.info-card-content {
    padding: 1.5rem;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 0;
    border-bottom: 1px solid #e8eef5;
    gap: 1rem;
}

.info-row:last-child {
    border-bottom: none;
}

.info-row.important {
    background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
    border-left: 4px solid #3388b3;
    margin: 0.5rem -1rem;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(51, 136, 179, 0.1);
}

.info-label {
    font-weight: 600;
    color: #0d3c61;
    min-width: 140px;
    flex-shrink: 0;
}

.info-value {
    font-weight: 500;
    color: #2c5282;
    text-align: right;
    flex: 1;
}

.numero-fattura-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.numero-fattura {
    font-weight: 600;
    flex: 1;
}

.fattura-actions {
    display: flex;
    gap: 0.5rem;
    margin-left: 1rem;
}

.error-border {
    border: 2px solid #e74c3c !important;
    box-shadow: 0 0 5px rgba(231, 76, 60, 0.3);
}

.field-error {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 4px;
    font-style: italic;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #2c3e50;
}

.action-btn {
    background: white;
    border: 1px solid;
    padding: 0.4rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

.download-btn {
    border-color: #dc3545;
    color: #dc3545;
}

.download-btn:hover {
    background: #dc3545;
    color: white;
    transform: translateY(-1px);
}

.view-btn {
    border-color: #6c757d;
    color: #6c757d;
}

.view-btn:hover {
    background: #6c757d;
    color: white;
    transform: translateY(-1px);
}

.used2-btn {
    border-color: #ffc107;
    color: #ffc107;
}

.used2-btn:hover {
    background: #ffc107;
    color: white;
    transform: translateY(-1px);
}

.link-pod {
    color: #3388b3;
    text-decoration: none;
    transition: all 0.2s;
    font-weight: 500;
}

.link-pod:hover {
    color: #0d3c61;
    text-decoration: underline;
}

.consumo-values {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.consumo-item {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 100px;
}

.consumo-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #3388b3;
    margin-bottom: 0.25rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.consumo-value {
    font-weight: 700;
    font-size: 1rem;
    color: #0d3c61;
}

.fatture-table-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    overflow: hidden;
    margin-bottom: 2rem;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.fatture-table-header {
    background: linear-gradient(135deg, #0d3c61, #1a5490);
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.fatture-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, #f8fafc, #e2e8f0);
}

.summary-item {
    background: white;
    padding: 1.5rem;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
}

.summary-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.summary-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
}

.summary-item:nth-child(1)::before {
    background: #3498db;
}

.summary-item:nth-child(2)::before {
    background: #2ecc71;
}

.summary-item:nth-child(3)::before {
    background: #f39c12;
}

.summary-label {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
    margin-right: 10px;
}

.summary-value {
    font-size: 1.5rem;
    font-weight: 700;
    color: #0d3c61;
}

.fatture-table-wrapper {
    overflow-x: auto;
    max-width: 100%;
}

.fatture-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.85rem;
    min-width: 800px;
}

.fatture-table thead {
    background: linear-gradient(135deg, #e1edf7, #d1e3f4);
}

.fatture-table th {
    padding: 1rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #0d3c61;
    border-bottom: 2px solid #c5d3e4;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.fatture-table td {
    padding: 0.75rem;
    text-align: left;
    border-bottom: 1px solid #e8eef5;
    color: #374151;
    font-weight: 500;
    white-space: nowrap;
}

.fatture-table tbody tr:nth-child(even) {
    background-color: #f8fafc;
}

.fatture-table tbody tr:hover {
    background-color: #e8f4fd;
    transition: background-color 0.2s ease;
}

.text-center {
    text-align: center !important;
}

.status-icon {
    font-weight: bold;
    font-size: 1rem;
}

.status-icon.success {
    color: #22c55e;
}

.status-icon.error {
    color: #ef4444;
}

.no-data-message {
    text-align: center;
    padding: 2rem;
    color: #64748b;
    font-style: italic;
}

.pagination-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    background: #f8fafc;
    border-top: 1px solid #e8eef5;
}

.pagination-info {
    font-size: 0.85rem;
    color: #64748b;
    font-weight: 500;
}

.pagination-controls {
    display: flex;
    gap: 0.5rem;
    align-items: center;
}

.pagination-btn {
    background: white;
    border: 1px solid #d1d5db;
    color: #374151;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
    background: #f3f4f6;
    border-color: #9ca3af;
    transform: translateY(-1px);
}

.pagination-btn:disabled {
    background: #f9fafb;
    color: #d1d5db;
    cursor: not-allowed;
    border-color: #e5e7eb;
}

.page-indicator {
    padding: 0.5rem 1rem;
    font-weight: 600;
    color: #0d3c61;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    min-width: 80px;
    text-align: center;
}

.fattura-controls-container {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(13, 60, 97, 0.1);
    padding: 1.5rem;
    border: 1px solid rgba(13, 60, 97, 0.1);
}

.approval-actions {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.approval-button {
    padding: 0.875rem 2rem;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 160px;
    position: relative;
    overflow: hidden;
}

.approve-button {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: white;
}

.approve-button:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(34, 197, 94, 0.3);
}

.reject-button {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.reject-button:hover {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(239, 68, 68, 0.3);
}

.consumo-fatturato-rosso,
.potenza-fatturata-rosso,
.imponibile-fattura-rosso {
    background: linear-gradient(135deg, #fef2f2, #fee2e2) !important;
    color: #dc2626 !important;
    font-weight: 700 !important;
    padding: 0.5rem 0.75rem !important;
    border-radius: 6px !important;
    border: 1px solid #fca5a5 !important;
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1) !important;
}

.consumo-anomalo,
.potenza-anomala,
.imponibile-anomalo {
    background: linear-gradient(135deg, #fef2f2, #fee2e2) !important;
    border-left-color: #dc2626 !important;
    border-left-width: 4px !important;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.modal-header {
    color: white;
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.modal-header-approve {
    background: linear-gradient(135deg, #22c55e, #16a34a);
}

.modal-header-reject {
    background: linear-gradient(135deg, #ef4444, #dc2626);
}

.close-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    font-size: 1.2rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.close-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
}

.modal-body {
    padding: 1.5rem;
}

.compact-body {
    padding: 1.5rem;
}

.modal-message {
    font-size: 1rem;
    margin-bottom: 1rem;
    line-height: 1.5;
    color: #374151;
}

.form-group {
    margin-bottom: 1rem;
    text-align: left;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #0d3c61;
}

.form-group textarea {
    width: 100%;
    padding: 0.75rem;
    border-radius: 8px;
    font-family: inherit;
    font-size: 0.9rem;
    resize: vertical;
    transition: all 0.2s;
    border: 1px solid #d1d5db;
}

.textarea-approve {
    border: 2px solid #27ae60;
}

.textarea-reject {
    border: 2px solid #e74c3c;
}

.textarea-approve:focus {
    outline: none;
    border-color: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

.textarea-reject:focus {
    outline: none;
    border-color: #ef4444;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.modal-footer {
    padding: 1.5rem;
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    border-top: 1px solid #e5e7eb;
    background: #f8fafc;
}

.btn-cancel,
.btn-submit,
.btn-success,
.btn-secondary,
.btn-success-approve,
.btn-success-reject {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    position: relative;
    overflow: hidden;
}

.btn-cancel {
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
}

.btn-cancel:hover {
    background: #e5e7eb;
}

.btn-secondary {
    background: #64748b;
    color: white;
    min-width: 140px;
}

.btn-secondary:hover {
    background: #475569;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(100, 116, 139, 0.3);
}

.btn-approve {
    background: linear-gradient(135deg, #22c55e, #16a34a);
    color: white;
}

.btn-approve:hover {
    background: linear-gradient(135deg, #16a34a, #15803d);
    transform: translateY(-1px);
}

.btn-reject {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
}

.btn-reject:hover {
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    transform: translateY(-1px);
}

.btn-success-approve {
    background: #22c55e;
    color: white;
}

.btn-success-approve:hover {
    background: #16a34a;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(34, 197, 94, 0.4);
}

.btn-success-reject {
    background: #ef4444;
    color: white;
}

.btn-success-reject:hover {
    background: #dc2626;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(239, 68, 68, 0.4);
}

.btn-secondary::before,
.btn-success::before,
.btn-success-approve::before,
.btn-success-reject::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transition: all 0.4s ease;
    transform: translate(-50%, -50%);
}

.btn-secondary:active::before,
.btn-success:active::before,
.btn-success-approve:active::before,
.btn-success-reject:active::before {
    width: 120%;
    height: 120%;
}

.btn-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none !important;
}

.error-message {
    color: #dc2626;
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 0.75rem;
    margin-top: 1rem;
    font-size: 0.9rem;
}

.success-message {
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #374151;
}

.success-details {
    font-size: 0.9rem;
    color: #64748b;
    line-height: 1.5;
}

.totali-row {
    font-size: medium;
    background-color: #bdd3e7;
    color: white;
}

@media (max-width: 1200px) {
    .fatturazione-dashboard {
        max-width: 100%;
        padding: 1rem;
    }

    .fatture-table {
        font-size: 0.8rem;
        min-width: 700px;
    }
}

@media (max-width: 768px) {
    .cards-container {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .fatture-summary {
        grid-template-columns: 1fr;
        padding: 1rem;
    }

    .approval-actions {
        flex-direction: column;
    }

    .approval-button {
        width: 100%;
    }

    .pagination-container {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .dashboard-title {
        font-size: 1.5rem;
    }

    .fatture-table {
        font-size: 0.75rem;
        min-width: 600px;
    }

    .fatture-table th,
    .fatture-table td {
        padding: 0.5rem 0.25rem;
    }
}

@media (max-width: 480px) {
    .fatturazione-dashboard {
        padding: 0.5rem;
    }

    .info-card-content {
        padding: 1rem;
    }

    .info-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.25rem;
    }

    .info-row.important {
        margin: 0.5rem -0.5rem;
        padding: 0.75rem 1rem;
    }

    .numero-fattura-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
    }

    .fattura-actions {
        margin-left: 0;
    }

    .modal-content {
        width: 95%;
        margin: 1rem;
    }

    .modal-footer {
        flex-direction: column;
        gap: 0.75rem;
    }

    .btn-cancel,
    .btn-submit,
    .btn-secondary,
    .btn-success-approve,
    .btn-success-reject {
        width: 100%;
        justify-content: center;
        min-width: auto;
    }
}
</style>